import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../../../../components/comman/ErrorMessage";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MultiSelectDropdown from "../../../../../components/comman/MultiSelectDropdown";
import { Spinner } from "reactstrap";
import { useMemo } from "react";

export default function EmployeePermissions({
  firstFormData,
  setPageStatesMain,
  pageStatesMain,
  locationData,
  setCreationComplete,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState("");
  const [error, setError] = useState({});
  const [error2, setError2] = useState({});
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();
  const watchType = +watch("type");
  const [isTrack, setIsTrack] = useState(false);
  const [pageStates, setPageStates] = useState({
    siteList: [],
    departmentList: [],
    designationList: [],
    shiftList: [],
    officeList: [],
    customerList: [],
    customerSiteList: [],
    removeSitesList: [],
    companyList: [],
    selectedSites: [],
    selectedCustomer: [],
    selectedCompanies: [],
    isAssignedAllSite: locationData?.isAssignedAllSite || false,
    loadingSite: false,
    loadingCustomerCompany: false,
    loadingDepartments: false,
    loadingDesignations: false,
  });
  const [selectedSitesComputed, setSelectedSitesComputed] = useState([]);
  console.log("locationData", locationData != undefined)
  useEffect(() => {
    reset({
      company: pageStatesMain?.selectedPayrollCompanyId,
    });
  }, [pageStatesMain?.selectedPayrollCompanyId]);

  useEffect(() => {
    GetCustomerCompanyList();
    GetCompanyList();
    if (locationData) {
      GetDepartments(locationData?.type);
      GetShifts(locationData?.type);
      const ids = locationData?.usercompanies?.map((comp) => comp.Company?.id);
      const preselectedCustomers =
        locationData?.usercustomers?.map((cust) => {
          return {
            id: cust?.customer?.id,
            name: cust?.customer?.name,
          };
        }) || [];
      if (locationData?.usercompanies?.length > 0) {
        const customerIds = (preselectedCustomers ?? []).map((c) => c.id);
        GetSites(
          locationData?.assignedSiteType,
          ids,
          "assignedCompanies",
          true,
          customerIds
        );
      } else {
        GetSites(
          locationData?.assignedSiteType,
          locationData?.companyId,
          "company",
          true,
          locationData?.usercustomers?.[0]?.customer?.id
        );
      }
      GetOffices();
      if (locationData?.permissions) {
        setPermissions(locationData.permissions);
      }

      const departmentId = locationData?.departmentId;
      if (departmentId) {
        GetDesignations(departmentId);
      }

      setIsTrack(true);
      setTimeout(() => {
        reset({
          companyId: locationData?.companyId,
          shiftId: locationData?.shiftId,
          designationId: locationData?.designationId,
          designationName: locationData?.designationName,
          departmentId: locationData?.departmentId,
          officeId: locationData?.officeId,
          siteType: locationData?.assignedSiteType,
          type: locationData?.type,
        });
        const preselectedCompanies = locationData?.usercompanies?.map(
          (userSite) => ({
            ...userSite,
            id: userSite?.Company?.id,
            name: userSite?.Company?.name,
          })
        );

        const preselectedSites = locationData?.usersites?.map((userSite) => ({
          customerId: userSite?.site?.customerId,
          id: userSite?.site?.id,
          name: userSite?.site?.name,
        }));

        setPageStates((prev) => ({
          ...prev,
          selectedCompanies: preselectedCompanies || [],
          selectedCustomer: preselectedCustomers || [],
          selectedSites: preselectedSites || [],
        }));
        setSelectedSitesComputed(preselectedSites);
      }, 1500);
    }
  }, [locationData, reset]);

  const GetSites = (type, data, temp, reset, customerId = null) => {
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_site}${type === "O&M"
      ? `?type=O%26M&status=1`
      : type === "project"
        ? `?type=project&status=1`
        : "?type=site&status=1"
      }`;
    if (temp == "company") {
      API = API + `&companyId=${data}`;
    } else if (temp == "assignedCompanies") {
      API =
        API + `&companyIdArr=${data && data.join(",").replace(/['"]/g, "")}`;
    }
    if (customerId) {
      API =
        API +
        `&${locationData?.type == 1 || watchType == 1
          ? `customerIdArr=${customerId.join(",").replace(/['"]/g, "")}`
          : `customerId=${customerId}`
        }`;
    }
    setPageStates((prev) => ({
      ...prev,
      loadingSite: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingSite: false,
      }));
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          siteList: response?.data?.site,
        }));
        if (reset) {
          setPageStates((prev) => ({
            ...prev,
            selectedSites: [],
          }));
        }
      }
    });
  };
  const GetOffices = () => {
    let options = {
      method: "GET",
    };
    const API = apiUrl.get_site + `?pageNumber=1&pageSize=50&type=office`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          officeList: response?.data?.site,
        }));
      }
    });
  };

  const GetCompanyList = () => {
    let options = {
      method: "GET",
    };
    const API = apiUrl.get_company + `?pageNumber=1&pageSize=50`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          companyList: response?.data?.company,
          selectedCompanies: response?.data?.company?.filter(
            (item) => item?.id === firstFormData?.companyId
          ),
        }));
      }
    });
  };

  const GetCustomerCompanyList = (id = null) => {
    let options = {
      method: "GET",
    };
    const API = `${apiUrl.get_customer}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          customerList: response?.data?.customer,
        }));
      }
    });
  };

  const GetDepartments = (type) => {
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_department}${type == 0 ? "?type=site" : type == 1 ? "?type=office" : ""
      }`;
    setPageStates((prev) => ({
      ...prev,
      loadingDepartments: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingDepartments: false,
      }));
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          departmentList: response?.data?.department,
        }));
      }
    });
  };
  const GetDesignations = (departmentId) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_designation + `?departmentId=${departmentId}`;
    setPageStates((prev) => ({
      ...prev,
      loadingDesignations: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        loadingDesignations: false,
      }));
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          designationList: response?.data?.designation,
        }));
      }
    });
  };
  const GetShifts = (type) => {
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_shift}${type == 0 ? "?type=Site" : type == 1 ? "?type=Office" : ""
      }`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          shiftList: response?.data?.shift,
        }));
      }
    });
  };
  // const handleCheckboxChange = (event) => {
  //   const { id, checked } = event.target;

  //   setPermissions((prevPermissions) => {
  //     const permissionsArray = prevPermissions
  //       ? prevPermissions.split(",")
  //       : [];

  //     if (checked) {
  //       if (!permissionsArray.includes(id)) {
  //         permissionsArray.push(id);
  //       }
  //     } else {
  //       const index = permissionsArray.indexOf(id);
  //       if (index > -1) {
  //         permissionsArray.splice(index, 1);
  //       }
  //     }
  //     return permissionsArray.join(",");
  //   });
  // };

  const handleCompanyChange = (selectedOptions) => {
    setPageStates((prev) => ({
      ...prev,
      selectedCompanies: selectedOptions,
      selectedSites: [],
      siteList: [],
    }));
    const siteType = watch("siteType");
    // console.log(">>", siteType);

    if (siteType) {
      const ids = selectedOptions?.map((comp) => comp.id);
      GetSites(siteType, ids, "assignedCompanies", true);
    }
    setError2((prev) => ({ ...prev, companies: null }));
  };

  const selectedCustomerIds = useMemo(() => {
    if (watchType !== 1) return new Set();
    const selectedIds = new Set(
      (pageStates?.selectedCustomer ?? []).map((c) => c.id)
    );
    return selectedIds;
  }, [watchType, pageStates?.selectedCustomer]);

  const siteOptions = useMemo(() => {
    if (watchType !== 1) return [];
    return (pageStates?.siteList ?? []).filter((s) =>
      selectedCustomerIds.has(s.customerId)
    );
  }, [watchType, pageStates?.siteList, selectedCustomerIds]);

  const removedSiteIds = useMemo(() => {
    if (watchType !== 1 || isTrack) return new Set();
    return new Set((pageStates?.removeSitesList ?? []).map((s) => s.id));
  }, [watchType, pageStates?.removeSitesList]);

  useEffect(() => {
    if (watchType === 1 && isTrack == false) {
      setSelectedSitesComputed(
        siteOptions.filter((s) => !removedSiteIds.has(s.id))
      );
      setIsTrack(false);
    }
  }, [watchType, siteOptions, removedSiteIds]);

  const handleChangeCustomerCompany = (selectOptions) => {
    setIsTrack(false);
    const siteType = watch("siteType");
    if (watchType == 0) {
      const companyId = watch("companyId");
      setPageStates((prev) => ({
        ...prev,
        selectedCustomer: selectOptions ?? [],
      }));
      GetSites(siteType, companyId, "company", true, selectOptions?.[0]?.id);
    } else {
      const prevIds = new Set(
        (pageStates?.selectedCustomer ?? []).map((c) => c.id)
      );
      const nextIds = new Set((selectOptions ?? []).map((c) => c.id));

      const removedCustomerIds = [...prevIds].filter((id) => !nextIds.has(id));

      const addedCustomerIds = [...nextIds].filter((id) => !prevIds.has(id));

      let prunedRemoveSitesList = (pageStates?.removeSitesList ?? []).filter(
        (s) => !removedCustomerIds.includes(s.customerId)
      );

      if (addedCustomerIds.length > 0) {
        prunedRemoveSitesList = prunedRemoveSitesList.filter(
          (s) => !addedCustomerIds.includes(s.customerId)
        );
      }
      setPageStates((prev) => ({
        ...prev,
        selectedCustomer: selectOptions ?? [],
        removeSitesList: prunedRemoveSitesList,
      }));
      const assignedCompanyIds =
        pageStates?.selectedCompanies?.map((c) => c.id) ?? [];
      const customerIds = (selectOptions ?? []).map((c) => c.id);
      GetSites(
        siteType,
        assignedCompanyIds,
        "assignedCompanies",
        false,
        customerIds
      );
    }

    setError((prev) => ({ ...prev, customer: null }));
  };

  const handleSiteChange = (selectedOptions) => {
    if (watchType === 1) {
      const selectedIds = new Set((selectedOptions ?? []).map((s) => s.id));

      const prevSelectedIds = new Set(selectedSitesComputed.map((s) => s.id));

      const newlyDeselected = selectedSitesComputed.filter(
        (s) => !selectedIds.has(s.id)
      );

      const reselectedIds = (selectedOptions ?? [])
        .map((s) => s.id)
        .filter((id) =>
          (pageStates?.removeSitesList ?? []).some((r) => r.id === id)
        );

      const updatedRemoveList = (pageStates?.removeSitesList ?? [])
        .filter((r) => !reselectedIds.includes(r.id))
        .concat(newlyDeselected);

      const stillSelectedCustomerIds = new Set(
        (selectedOptions ?? []).map((s) => s.customerId)
      );
      const updatedSelectedCustomers = (
        pageStates?.selectedCustomer ?? []
      ).filter((c) => stillSelectedCustomerIds.has(c.id));

      setPageStates((prev) => ({
        ...prev,
        removeSitesList: updatedRemoveList,
        selectedCustomer: updatedSelectedCustomers,
      }));
    } else {
      setPageStates((prev) => ({
        ...prev,
        selectedSites: selectedOptions,
      }));
    }
    setError((prev) => ({ ...prev, sites: null }));
  };

  useEffect(() => {
    if (watchType == 1 && !locationData) {
      const prev = pageStates?.selectedSites ?? [];
      const next = selectedSitesComputed;

      const same =
        prev.length === next.length &&
        prev.every((p) => next.some((n) => n.id === p.id));

      if (!same) {
        setPageStates((prevState) => ({ ...prevState, selectedSites: next }));
      }
    }
  }, [selectedSitesComputed]);

  const onSubmit = (data) => {
    if (!firstFormData && !locationData) {
      toast.info("Please Fill Basic Details Form Before Creation!");
      return;
    }
    if (watchType === 1 && pageStates?.selectedCompanies?.length === 0) {
      setError2((prev) => ({
        ...prev,
        companies: "Please select at least one company.",
      }));
      return;
    }
    const companyIds = pageStates?.selectedCompanies?.map((comp) => comp.id);

    if (pageStates?.selectedSitesComputed?.length === 0) {
      setError((prev) => ({
        ...prev,
        sites: "Please select at least one site.",
      }));
      return;
    }
    if (pageStates?.selectedCustomer?.length === 0) {
      setError((prev) => ({
        ...prev,
        customer: "Please select at least one customer.",
      }));
      return;
    }
    const siteIds =
      watchType == 1
        ? selectedSitesComputed?.map((site) => site.id)
        : pageStates?.selectedSites?.map((site) => site.id);
    const customerIds = pageStates?.selectedCustomer?.map((cu) => cu.id);

    const secondFormData = { ...data, permissions, siteIds, customerIds };
    const submitData = { ...firstFormData, ...secondFormData };

    const formData = new FormData();
    formData.append(
      "name",
      (submitData?.firstName || "").trim() +
      " " +
      (submitData?.lastName || "").trim()
    );
    formData.append("email", submitData?.email);
    formData.append("phone", submitData?.phone);
    formData.append("dob", submitData?.dob);
    formData.append("gender", submitData?.gender);
    formData.append("bloodGroup", submitData?.bloodGroup);
    formData.append("profilePhoto", submitData?.profilePhoto);
    formData.append("fatherName", submitData?.fatherName);
    formData.append("motherName", submitData?.motherName);
    formData.append("isMarried", submitData?.isMarried);
    formData.append("skillType", submitData?.skillType);
    formData.append("status", submitData?.status);
    formData.append("joiningDate", submitData?.joiningDate);
    formData.append("shiftId", submitData?.shiftId);
    if (watchType == 1) {
      formData.append(
        "assignedCompanies",
        companyIds?.length > 0 && JSON.stringify(companyIds)
      );
    }
    formData.append("siteId", siteIds?.length > 0 && JSON.stringify(siteIds));
    formData.append(
      "customerId",
      customerIds?.length > 0 && JSON.stringify(customerIds)
    );
    formData.append("designationId", submitData?.designationId);
    formData.append("designationName", submitData?.designationName);
    formData.append("departmentId", submitData?.departmentId);
    // formData.append("permissions", submitData?.permissions);
    formData.append("siteType", submitData?.siteType);
    formData.append("type", submitData?.type);
    formData.append("addingUser", true);
    formData.append("assignedSiteType", submitData?.siteType);
    formData.append("isAssignedAllSite", pageStates?.isAssignedAllSite);
    if (data?.type == 1) {
      formData.append("officeId", submitData?.officeId);
    }
    formData.append("companyId", submitData?.companyId);

    //Update>>>>>>>>>
    const formDataWhenUpdate = new FormData();
    formDataWhenUpdate.append("shiftId", submitData?.shiftId);

    if (watchType == 1) {
      formDataWhenUpdate.append(
        "assignedCompanies",
        siteIds?.length > 0 && JSON.stringify(companyIds)
      );
    }
    formDataWhenUpdate.append(
      "siteId",
      siteIds?.length > 0 && JSON.stringify(siteIds)
    );
    formDataWhenUpdate.append(
      "customerId",
      customerIds?.length > 0 && JSON.stringify(customerIds)
    );
    formDataWhenUpdate.append("designationId", submitData?.designationId);
    formDataWhenUpdate.append("designationName", submitData?.designationName);
    formDataWhenUpdate.append("departmentId", submitData?.departmentId);
    formDataWhenUpdate.append("siteType", submitData?.siteType);
    formDataWhenUpdate.append("type", submitData?.type);
    formDataWhenUpdate.append("assignedSiteType", submitData?.siteType);
    formDataWhenUpdate.append("companyId", submitData?.companyId);
    formDataWhenUpdate.append(
      "isAssignedAllSite",
      pageStates?.isAssignedAllSite
    );
    if (data?.type == 1) {
      formDataWhenUpdate.append("officeId", submitData?.officeId);
    } else {
      formDataWhenUpdate.append("officeId", null);
    }
    formDataWhenUpdate.append("activeTab", "Permissions");

    if (locationData) {
      const options = {
        method: "POST",
        form_data: formDataWhenUpdate,
      };
      let API = apiUrl?.add_employee + `?userId=${locationData?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          setPageStatesMain((prev) => ({
            ...prev,
            activeTab: 3,
          }));
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      const options = {
        method: "POST",
        form_data: formData,
      };
      let API = apiUrl?.add_employee;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          setCreationComplete(true);
          setPageStatesMain((prev) => ({
            ...prev,
            activeTab: 3,
            Id_onCreateEmp: response?.data?.user?.id,
          }));
        } else {
          toast.error(response?.message);
        }
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="card shadow-md border-0 rounded-3 mb-4">
        <div className="card-body px-4 py-3">
          <div className="ard-header bg-white border-bottom-0 pt-4 pb-2 px-4">
            <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
              Permission
            </h4>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  OnRoll Company
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("companyId", {
                    required: "Please select Company",
                    onChange: (e) => {
                      setValue("type", "");
                      setValue("officeId", "");
                      setValue("siteType", "");
                      setPageStates((prev) => ({
                        ...prev,
                        selectedCompanies: [],
                      }));
                      setPageStates((prev) => ({
                        ...prev,
                        selectedSites: [],
                      }));
                      setValue("departmentId", "");
                      setValue("designationId", "");
                      setValue("shiftId", "");
                      setValue("company", locationData?.companyId);
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        GetDepartments(selectedValue);
                        GetShifts(selectedValue);
                      }
                      if (selectedValue == 1) {
                        GetOffices();
                      }
                    },
                  })}
                  disabled={locationData != undefined}
                >
                  <option value="" className="d-none">
                    Select Company
                  </option>
                  {pageStates?.companyList?.length > 0 ? (
                    pageStates?.companyList?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })
                  ) : (
                    <option disabled value="">
                      No data found
                    </option>
                  )}
                </select>
                <ErrorMessage message={errors?.companyId?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Employee Type
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("type", {
                    required: "Please select Employee Type",
                    onChange: (e) => {
                      GetCompanyList();
                      setValue("type", e?.target?.value);
                      setValue("officeId", "");
                      setValue("siteType", "");
                      setPageStates((prev) => ({
                        ...prev,
                        selectedCompanies: [],
                      }));
                      setPageStates((prev) => ({
                        ...prev,
                        selectedSites: [],
                        siteList: [],
                      }));
                      setValue("departmentId", "");
                      setValue("designationId", "");
                      setValue("shiftId", "");
                      setValue("company", locationData?.companyId);
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        GetDepartments(selectedValue);
                        GetShifts(selectedValue);
                      }
                      if (selectedValue == 1) {
                        GetOffices();
                      }
                    },
                  })}
                  disabled={locationData != undefined}
                >
                  <option value="" className="d-none">
                    Select Employee Type
                  </option>
                  <option value={0}>Site Staff</option>
                  <option value={1}>Office Staff</option>
                </select>
                <ErrorMessage message={errors?.type?.message} />
              </div>
            </div>

            {watchType == 1 && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="form-group mb-3">
                  <label htmlFor="Role" className="form-label">
                    Assign Company
                    <span className="text-danger">*</span>
                  </label>
                  <MultiSelectDropdown
                    options={pageStates?.companyList || []}
                    selectedValues={pageStates?.selectedCompanies}
                    onChange={handleCompanyChange}
                    multiSelect={watchType == 1 ? true : false}
                    setPageStates={setPageStates}
                  />
                  {error2.companies && <ErrorMessage message={error2.companies} />}
                </div>
              </div>
            )}

            {watchType == 1 && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="form-group mb-3">
                  <label htmlFor="Role" className="form-label">
                    Office
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-control"
                    aria-label="Default select example"
                    {...register("officeId", {
                      required: watchType == 1 ? "Please select Office" : false,
                    })}
                  // disabled={locationData != undefined}
                  >
                    <option value="" className="d-none">
                      Select Office
                    </option>
                    {pageStates?.officeList?.length > 0 &&
                      pageStates?.officeList?.map((item, index) => {
                        return (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </select>
                  <ErrorMessage message={errors?.officeId?.message} />
                </div>
              </div>
            )}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Site Type
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("siteType", {
                    required: "Please select Site Type",
                    onChange: (e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        if (watchType == 1) {
                          if (pageStates?.selectedCompanies?.length === 0) {
                            toast.info("Please Select company");
                            return;
                          }
                        }
                        if (watchType == 0) {
                          const companyId = getValues("companyId");
                          GetSites(selectedValue, companyId, "company", true);
                        } else if (watchType == 1) {
                          const companyIds = pageStates?.selectedCompanies?.map(
                            (comp) => comp.id
                          );
                          GetSites(
                            selectedValue,
                            companyIds,
                            "assignedCompanies",
                            true
                          );
                        }
                        setPageStates((prev) => ({
                          ...prev,
                          selectedSites: [],
                        }));
                      }
                    },
                  })}
                // disabled={locationData != undefined}
                >
                  <option value="" className="d-none">
                    Select Site Type
                  </option>
                  <option value={"O&M"}>O&amp;M</option>
                  <option value={"project"}>Project</option>
                  {Number(watchType) === 1 && <option value={"both"}>Both</option>}
                </select>
                <ErrorMessage message={errors?.siteType?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Customer
                  <span className="text-danger">*</span>
                </label>
                <MultiSelectDropdown
                  options={pageStates?.customerList || []}
                  selectedValues={pageStates?.selectedCustomer}
                  onChange={handleChangeCustomerCompany}
                  multiSelect={watchType == 1 ? true : false}
                  setPageStates={setPageStates}
                  isLoading={pageStates.loadingCustomerCompany}
                // disabled={locationData?.isSalaryCreated}
                />
                {error.customer && <ErrorMessage message={error.customer} />}
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Site
                  <span className="text-danger">*</span>
                </label>
                <MultiSelectDropdown
                  options={watchType == 1 ? siteOptions : pageStates?.siteList}
                  selectedValues={
                    watchType == 1
                      ? selectedSitesComputed
                      : pageStates?.selectedSites
                  }
                  onChange={handleSiteChange}
                  multiSelect={watchType == 1 ? true : false}
                  setPageStates={setPageStates}
                  isLoading={pageStates.loadingSite}
                // disabled={locationData?.isSalaryCreated}
                />
                {error.sites && <ErrorMessage message={error.sites} />}
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Department
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  disabled={
                    pageStates?.loadingDepartments || locationData != undefined
                  }
                  {...register("departmentId", {
                    required: "Please select Department",
                    onChange: (e) => {
                      setValue("designationId", "");
                      const selectedValue = e.target.value;
                      if (selectedValue) {
                        GetDesignations(selectedValue);
                      }
                    },
                  })}
                >
                  {pageStates?.loadingDepartments ? (
                    <option value="">Loading...</option>
                  ) : (
                    <>
                      <option value="" className="d-none">
                        Select Department
                      </option>
                      {pageStates?.departmentList?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
                <ErrorMessage message={errors?.departmentId?.message} />
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  System Permission
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  // disabled={
                  //   pageStates?.loadingDesignations || locationData != undefined
                  // } 
                  disabled={pageStates?.loadingDesignations}
                  {...register("designationId", {
                    required: "Please select System Permission",
                  })}
                  onChange={(e) => {
                    const selectedText = e.target.options[e.target.selectedIndex].text;
                    setValue("designationName", selectedText);
                  }}
                >
                  {pageStates?.loadingDesignations ? (
                    <option value="">Loading...</option>
                  ) : (
                    <>
                      <option value="" className="d-none">
                        Select Designation
                      </option>
                      {pageStates?.designationList?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
                <ErrorMessage message={errors?.designationId?.message} />
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  Shift
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("shiftId", {
                    required: "Please select Shift",
                  })}
                >
                  <option value="" className="d-none">
                    Select Shift
                  </option>
                  {pageStates?.shiftList?.length > 0 &&
                    pageStates?.shiftList?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.shiftName}
                        </option>
                      );
                    })}
                </select>
                <ErrorMessage message={errors?.shiftId?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group mb-3">
                <label htmlFor="firstName" className="form-label">
                  Designation Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Plant Head, Sr.Engineer, Helper etc."
                  id="firstName"
                  maxLength={160}
                  aria-describedby="emailHelp"
                  {...register("designationName",
                    {
                      required: "Please enter designation name",
                    }
                  )}
                // disabled={locationData?.designationName}
                />
                <ErrorMessage message={errors?.designationName?.message} />
              </div>
            </div>
            {/* <div className="col-12">
          <h4 className="fs-4 rajdhani-semibold my-4 border-bottom pb-3">
            Access
          </h4>

          <div className="d-flex gap-5 align-items-center">
            {["create", "edit", "delete"].map((permission, index) => (
              <div key={permission} className="form-check form-group p-0">
                <div key={index} className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id={permission}
                    checked={permissions.includes(permission)}
                    onChange={handleCheckboxChange}
                  />
                  <label className="form-check-label" htmlFor={permission}>
                    {permission.charAt(0).toUpperCase() + permission.slice(1)}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div> */}
          </div>
        </div>
        <div className="card-footer bg-white border-top py-3 px-4 d-flex align-items-center justify-content-end rounded-bottom-3">
          <button className="btn btn-primary px-4 fw-semibold shadow-sm d-flex align-items-center gap-2" type="submit" disabled={isLoading}>
            {isLoading && <Spinner size="sm" />}
            {locationData ? (isLoading ? "Updating..." : "Update and Continue") : (isLoading ? "Creating..." : "Update and Continue")}
          </button>
        </div>
      </div>
    </form>
  );
}
